import { Box, HStack } from "@chakra-ui/react";

import { useAppSelector } from "../../../app/hooks";
import { UserPermissionLevel } from "../../../config/constants";
import { mainSections } from "../../../siteMap/mainSections";
import { getSelectedRows } from "../../../store/selectedRowsSlice";
import ProtectedComponentByRole from "../../protectedByRole/protectedComponentByRole";

import AppMenuItem from "./navItem/navItem";

const NavButtons = () => {
  const mainTestSection = mainSections.find(section => section.label === "Artesian");
  const selectedRows = useAppSelector(getSelectedRows);
  // Filter menu items to exclude those with isInMenu: false
  const menuItems =
    mainTestSection?.subsections
      ?.filter(item => item.isInMenu) // Exclude items where isInMenu is false
      .map(item => ({
        ...item,
        disabled: item.label === "Basket" ? selectedRows?.length === 0 : item.disabled,
      })) ?? [];

  return (
    <HStack gap={4} mr={4}>
      {menuItems.map((item, index) => {
        const menuButton = (
          <AppMenuItem
            path={item.path}
            label={item.label}
            icon={item.icon}
            disabled={item.disabled}
            count={item.label === "Basket" ? selectedRows?.length : undefined}
          />
        );

        if (item.label === "Expectation Monitor") {
          return (
            <ProtectedComponentByRole
              key={item.path + "navButton" + index}
              pageKey="expectation"
              roleType={UserPermissionLevel.Read}
              children={menuButton}
            />
          );
        }

        return <Box key={item.path + "navButton" + index}>{menuButton}</Box>;
      })}
    </HStack>
  );
};

export default NavButtons;
